import authApi from "@/services/auth-api"
import type {
  MfaValidate,
  Login,
  MfaMailResendCode,
  LoginResponse,
  MfaValidateResponse
} from "@/types/auth"

export class AuthApi {
  public login = (credentials: Login) =>
    authApi.post<LoginResponse>("/api/v1/login", credentials)

  public logout = async () => {
    await authApi.post("/api/v1/access_revoke")
    await authApi.post("/api/v1/refresh_revoke")
  }

  public validateMfa = async (data: MfaValidate) =>
    authApi.post<MfaValidateResponse>("/api/v1/double-factor/validate", data)

  public resendCodeMfaMail = (username: MfaMailResendCode) =>
    authApi.post("/api/v1/double-factor/resend", username)
}
